import { ID } from "../../../../model/types"

export type MoveKey =
  | "read"
  | "extract"
  | "place"
  | "polish"
  | "wander"
  | "project"

export type MoveCardState = {
  move: MoveKey
  objectId: ID
}

export type ExcludeSets = Partial<Record<MoveKey, Set<ID>>>

/** Sentinel object id when there is no in-progress project to continue. */
export const NEW_PROJECT_SENTINEL: ID = "__new_project__"

/**
 * Fixed order for hand building / column sort.
 * Layout: left read→extract→place; right polish→wander→project.
 */
export const MOVE_KEYS: MoveKey[] = [
  "read",
  "extract",
  "place",
  "polish",
  "wander",
  "project",
]

export const MOVE_LABELS: Record<MoveKey, string> = {
  read: "Read",
  extract: "Extract",
  place: "Place",
  polish: "Polish",
  wander: "Wander",
  project: "Continue",
}
